import { Megaphone, ArrowUpRight } from "lucide-react";

const manilaToday = () => new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Manila" });

export const NewsStrip = ({ settings }) => {
  const { announcement, announcement_link: link, announcement_until: until } = settings;
  if (!announcement || (until && until < manilaToday())) return null;
  const Inner = (
    <>
      <span className="shrink-0 inline-flex items-center gap-1.5 rounded-full bg-[#4A2E1A] text-[#FDF7E7] px-3 py-1 text-[11px] font-bold uppercase tracking-[0.16em]">
        <Megaphone className="w-3.5 h-3.5" aria-hidden="true" /> Parish news
      </span>
      <span data-testid="news-strip-text" className="font-serif-head text-[15px] sm:text-base text-[#4A2E1A] leading-snug">{announcement}</span>
      {link && <ArrowUpRight className="w-4 h-4 shrink-0 text-[#8A6A2E] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" aria-hidden="true" />}
    </>
  );
  const cls = "group fade-up flex flex-wrap items-center gap-x-3 gap-y-1.5 rounded-2xl border border-[#E9D49A] bg-[#FDF7E7]/80 backdrop-blur-sm px-3 py-2.5 sm:px-4";
  return (
    <div className="max-w-6xl mx-auto px-5 pt-6" data-testid="news-strip">
      {link ? (
        <a href={link} target="_blank" rel="noopener noreferrer" data-testid="news-strip-link" className={`${cls} hover:border-[#C59B27] transition-colors`}>{Inner}</a>
      ) : (
        <div className={cls}>{Inner}</div>
      )}
    </div>
  );
};
